import React from 'react'
import ConfigAdminUI from './ConfigAdminUI'
import ConfigCustomerUI from './ConfigCustomerUI'

const ConfigUserInterfaces = (props) => {
  const {
    showAdminUI,
    showCustomerUI,
    adminUiDomain,
    setAdminUiDomain,
    adminUiCertificateGenerate,
    setAdminUiCertificateGenerate,
    adminUiCertficates,
    setAdminUiCertificates,
    adminUiSiteKey,
    setAdminUiSiteKey,
    adminUiSecretKey,
    setAdminUiSecretKey,
    adminUiLogo,
    setAdminUiLogo,
    adminUiPrimaryColor,
    setAdminUiPrimaryColor,
    adminUiSecondaryColor,
    setAdminUiSecondaryColor,
    customerUiDomain,
    setCustomerUiDomain,
    customerUiCertificateGenerate,
    setCustomerUiCertificateGenerate,
    customerUiCertficates,
    setCustomerUiCertificates,
    customerUiSiteKey,
    setCustomerUiSiteKey,
    customerUiSecretKey,
    setCustomerUiSecretKey,
    customerUiLogo,
    setCustomerUiLogo,
    customerUiPrimaryColor,
    setCustomerUiPrimaryColor,
    customerUiSecondaryColor,
    setCustomerUiSecondaryColor,
    defaultOpenStackDomain,
    setDefaultOpenStackDomain,
    defaultOpenStackUserRole,
    setDefaultOpenStackUserRole,
    signUpEnabled,
    setSignUpEnabled,
    isUsername,
    setIsUsername,
    usernamePriority,
    setUsernamePriority,
    isPassword,
    setIsPassword,
    passwordPriority,
    setPasswordPriority,
    isConfirmPassword,
    setIsConfirmPassword,
    confirmPasswordPriority,
    setConfirmPasswordPriority,
    isEmail,
    setIsEmail,
    emailPriority,
    setEmailPriority,
    isTermsOfUse,
    setIsTermsOfUse,
    termsOfUseText,
    setTermsOfUseText,
    termsOfUseFile,
    setTermsOfUseFile,
    termsOfUseUrlPrefix,
    setTermsOfUseUrlPrefix,
    termsOfUseUrl,
    setTermsOfUseUrl,
    termsOfUseType,
    setTermsOfUseType,
    isPrivacyPolicy,
    setIsPrivacyPolicy,
    privacyPolicyText,
    setPrivacyPolicyText,
    privacyPolicyFile,
    setPrivacyPolicyFile,
    privacyPolicyUrlPrefix,
    setPrivacyPolicyUrlPrefix,
    privacyPolicyUrl,
    setPrivacyPolicyUrl,
    privacyPolicyType,
    setPrivacyPolicyType,
    customFields,
    setCustomFields,
    backgroundType,
    setBackgroundType,
    colorType,
    setColorType,
    backgroundColor,
    setBackgroundColor,
    gradientColor1,
    setGradientColor1,
    gradientColor2,
    setGradientColor2,
    backgroundImage,
    setBackgroundImage,
    headingText,
    setHeadingText,
    promoText1,
    setPromoText1,
    promoText2,
    setPromoText2,
    promoText3,
    setPromoText3,
    isContact,
    setIsContact,
    contactCompany,
    setContactCompany,
    contactPhone,
    setContactPhone,
    contactEmail,
    setContactEmail,
    domainsWithCertififcates,
    backgroundTypeList,
    colorTypeList,
    verifyDomain,
    errors,
    setErrors,
    submitted,
    validateFormFields,
  } = props
  
  return (
    <>
      {
        showAdminUI &&
        <ConfigAdminUI
          adminUiDomain={adminUiDomain}
          setAdminUiDomain={setAdminUiDomain}
          adminUiCertificateGenerate={adminUiCertificateGenerate}
          setAdminUiCertificateGenerate={setAdminUiCertificateGenerate}
          adminUiCertficates={adminUiCertficates}
          setAdminUiCertificates={setAdminUiCertificates}
          adminUiSiteKey={adminUiSiteKey}
          setAdminUiSiteKey={setAdminUiSiteKey}
          adminUiSecretKey={adminUiSecretKey}
          setAdminUiSecretKey={setAdminUiSecretKey}
          adminUiLogo={adminUiLogo}
          setAdminUiLogo={setAdminUiLogo}
          adminUiPrimaryColor={adminUiPrimaryColor}
          setAdminUiPrimaryColor={setAdminUiPrimaryColor}
          adminUiSecondaryColor={adminUiSecondaryColor}
          setAdminUiSecondaryColor={setAdminUiSecondaryColor}
          domainsWithCertififcates={domainsWithCertififcates}
          verifyDomain={verifyDomain}
          errors={errors}
          submitted={submitted}
          validateFormFields={validateFormFields}
        />
      }
      
      {
        showCustomerUI &&
        <ConfigCustomerUI
          customerUiDomain={customerUiDomain}
          setCustomerUiDomain={setCustomerUiDomain}
          customerUiCertificateGenerate={customerUiCertificateGenerate}
          setCustomerUiCertificateGenerate={setCustomerUiCertificateGenerate}
          customerUiCertficates={customerUiCertficates}
          setCustomerUiCertificates={setCustomerUiCertificates}
          customerUiSiteKey={customerUiSiteKey}
          setCustomerUiSiteKey={setCustomerUiSiteKey}
          customerUiSecretKey={customerUiSecretKey}
          setCustomerUiSecretKey={setCustomerUiSecretKey}
          customerUiLogo={customerUiLogo}
          setCustomerUiLogo={setCustomerUiLogo}
          customerUiPrimaryColor={customerUiPrimaryColor}
          setCustomerUiPrimaryColor={setCustomerUiPrimaryColor}
          customerUiSecondaryColor={customerUiSecondaryColor}
          setCustomerUiSecondaryColor={setCustomerUiSecondaryColor}
          defaultOpenStackDomain={defaultOpenStackDomain}
          setDefaultOpenStackDomain={setDefaultOpenStackDomain}
          defaultOpenStackUserRole={defaultOpenStackUserRole}
          setDefaultOpenStackUserRole={setDefaultOpenStackUserRole}
          signUpEnabled={signUpEnabled}
          setSignUpEnabled={setSignUpEnabled}
          isUsername={isUsername}
          setIsUsername={setIsUsername}
          usernamePriority={usernamePriority}
          setUsernamePriority={setUsernamePriority}
          isPassword={isPassword}
          setIsPassword={setIsPassword}
          passwordPriority={passwordPriority}
          setPasswordPriority={setPasswordPriority}
          isConfirmPassword={isConfirmPassword}
          setIsConfirmPassword={setIsConfirmPassword}
          confirmPasswordPriority={confirmPasswordPriority}
          setConfirmPasswordPriority={setConfirmPasswordPriority}
          isEmail={isEmail}
          setIsEmail={setIsEmail}
          emailPriority={emailPriority}
          setEmailPriority={setEmailPriority}
          isTermsOfUse={isTermsOfUse}
          setIsTermsOfUse={setIsTermsOfUse}
          termsOfUseText={termsOfUseText}
          setTermsOfUseText={setTermsOfUseText}
          termsOfUseFile={termsOfUseFile}
          setTermsOfUseFile={setTermsOfUseFile}
          termsOfUseUrlPrefix={termsOfUseUrlPrefix}
          setTermsOfUseUrlPrefix={setTermsOfUseUrlPrefix}
          termsOfUseUrl={termsOfUseUrl}
          setTermsOfUseUrl={setTermsOfUseUrl}
          termsOfUseType={termsOfUseType}
          setTermsOfUseType={setTermsOfUseType}
          isPrivacyPolicy={isPrivacyPolicy}
          setIsPrivacyPolicy={setIsPrivacyPolicy}
          privacyPolicyText={privacyPolicyText}
          setPrivacyPolicyText={setPrivacyPolicyText}
          privacyPolicyFile={privacyPolicyFile}
          setPrivacyPolicyFile={setPrivacyPolicyFile}
          privacyPolicyUrlPrefix={privacyPolicyUrlPrefix}
          setPrivacyPolicyUrlPrefix={setPrivacyPolicyUrlPrefix}
          privacyPolicyUrl={privacyPolicyUrl}
          setPrivacyPolicyUrl={setPrivacyPolicyUrl}
          privacyPolicyType={privacyPolicyType}
          setPrivacyPolicyType={setPrivacyPolicyType}
          customFields={customFields}
          setCustomFields={setCustomFields}
          backgroundType={backgroundType}
          setBackgroundType={setBackgroundType}
          colorType={colorType}
          setColorType={setColorType}
          backgroundColor={backgroundColor}
          setBackgroundColor={setBackgroundColor}
          gradientColor1={gradientColor1}
          setGradientColor1={setGradientColor1}
          gradientColor2={gradientColor2}
          setGradientColor2={setGradientColor2}
          backgroundImage={backgroundImage}
          setBackgroundImage={setBackgroundImage}
          headingText={headingText}
          setHeadingText={setHeadingText}
          promoText1={promoText1}
          setPromoText1={setPromoText1}
          promoText2={promoText2}
          setPromoText2={setPromoText2}
          promoText3={promoText3}
          setPromoText3={setPromoText3}
          isContact={isContact}
          setIsContact={setIsContact}
          contactCompany={contactCompany}
          setContactCompany={setContactCompany}
          contactPhone={contactPhone}
          setContactPhone={setContactPhone}
          contactEmail={contactEmail}
          setContactEmail={setContactEmail}
          domainsWithCertififcates={domainsWithCertififcates}
          backgroundTypeList={backgroundTypeList}
          colorTypeList={colorTypeList}
          verifyDomain={verifyDomain}
          errors={errors}
          setErrors={setErrors}
          submitted={submitted}
          validateFormFields={validateFormFields}
        />
      }
    </>
  )
}

export default ConfigUserInterfaces